
import {GetterTree} from 'vuex';
import ISubPanel from "@/modules/SubPanels/ts/ISubPanel";

export const getters: GetterTree<any, any> = {

    findById: (state) => (id: number) => {
        let found = state.subPanels.find((sp: ISubPanel) => sp.id == id);

        // Return copy
        return Object.assign({}, found);
    },
}